// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qe-6";
export var imgContainer = "_qe-3";
export var menuIcon = "_qe-5";
export var pillWrapper = "_qe-2";
export var pillsContainer = "_qe-1";
export var subscriptionCard = "_qe-0";
export var subscriptionLogo = "_qe-4";